import Swal from 'sweetalert2';

const RADIX = 10;

export const emptyString = (string) => (!string || string.trim() === '');

export const isNotNull = (date) => (date !== null);

export const emptyArray = (string) => {
  if (typeof string === 'undefined' || string.length === 0) {
    return true;
  }
  return false;
}

export const formatCurrency = amount => {
  return parseFloat(amount)
    .toFixed(2).toString().replace('.', ',');
}

export const formatDate = date => {
  if (emptyString(date)) {
    return 'N/A';
  }
  const year = date.substring(0, 4);
  const month = date.substring(4, 6);
  const day = date.substring(6, 8);
  return `${day}/${month}/${year}`;
};

export const extractExpirationMonth = (expirationDate) => {
  return expirationDate.substring(0, 2).toString();
};

export const extractExpirationYear = (expirationDate) => {
  const shortYear = expirationDate.substring(2, 4);
  const longYear = shortYear + 2000;
  return (parseInt(longYear, RADIX)).toString();
};

export const isDevelopment = (process.env.NODE_ENV === 'development');
export const isProduction = (process.env.NODE_ENV === 'production');

export const loadingAlert = (title, text) => {
  Swal({
    animation: false,
    customClass: 'animation fadeIn bg-white',
    allowOutsideClick: false,
    title,
    text,
    showConfirmButton: false,
    allowEscapeKey: false,
    onOpen: () => {
      Swal.showLoading()
    }
  });
};

export const formatToBRL = (amount) => {
  return "R$ " +  parseFloat(amount)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
}

export const getMaxOfArray = (numArray) => Math.max.apply(null, numArray);

export const buildQueryString = (values) => {
  let queryString = '?';
  Object.keys(values).forEach((key) => {
    if (values[key] !== '') {
      queryString += `${key}=${values[key]}&`;
    }
    return key;
  });
  return queryString;
}


// WEBPACK FOOTER //
// ./src/helpers.js